<template lang="html">
  <transition>
    <div class="toasty" :class="{dark : darkmode}">
    <div class="innerBox">
      <p>{{text}}</p>
      <div class="container">
        <AveButton v-show="labelClose" :darkmode="darkmode" :icon="iconClose" icon-type="negative" :label="labelClose" @click="close" />
        <div class="gap"></div>
        <AveButton v-show="labelConfirm" :darkmode="darkmode" :icon="iconConfirm" icon-type="positive" :label="labelConfirm"  @click="handleAction" />
      </div>
      <div class="bottomDistance">
      </div>
    </div>
    </div>
  </transition>
</template>

<script>
import AveButton from '@/components/AveButton.vue';

export default {
  name: 'Components',
  components: {
    AveButton,
  },
  props: {
    action: Function,
    labelClose: String,
    labelConfirm: String,
    iconClose: String,
    iconConfirm: String,
    text: {
      type: String,
      default: 'Sad toasty  :(',
    },
    // visible: Boolean,
    darkmode: Boolean,
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleAction() {
      this.action();
    },
  },
};

</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

.toasty.v-enter-active,
.toasty.v-leave-active {
  transition: bottom 550ms cubic-bezier(0.68, -0.6, 0.32, 1.6);
}

.toasty.v-enter,
.toasty.v-leave-to {
  bottom: -200px;
}

.toasty
  position fixed
  bottom 0
  left 50%
  transform: translateX(-50%);
  z-index 1
  max-height 95%
  width 87.5%
  overflow-y scroll
  background-color $white
  border $borderBoxes
  border-color $normal
  border-radius $radiusBoxes
  font-size: 14pt
  color $normal

  .innerBox
    position relative;
    width 90%
    margin auto

  &.dark
    color: $darkmodeWhite
    background-color: $normal
    border-color: $darkmodeWhite


.container
  display flex
  flex-direction row

.gap
  width 17px

.bottomDistance
  height:60px

</style>
